<template>
  <div class="layer" style="background: #fff">
    <div class="blog-view">
      <h1>全球智库影响力评价研究</h1>
      <el-link  @click="go" type="primary" style="font-weight: 500;font-size:17px;;margin-top:10px">报告原文</el-link>
      <img src="static/img/home/gz3.jpg" class="tankImg" />
      <div class="blog-content">
        <p
          class="text"
        >纵观当今世界各国现代化发展历程，智库在国家治理中发挥着越来越重要的作用，日益成为国家治理体系中不可或缺的组成部分，是国家治理能力的重要体现。当前，中国全面建成小康社会进入决定性阶段，破解改革发展稳定难题和应对全球性问题的复杂性艰巨性前所未有，迫切需要健全中国特色决策支撑体系，大力加强智库建设，以科学咨询支撑科学决策，以科学决策引领科学发展。</p>
        <p
          class="text"
        >浙江大学信息资源分析与应用研究中心结合中国工程院知识中心“工程科技机构与专家库”项目的数据建设成果，成立专项组开展“全球智库评价及排名”的研究工作，这是全世界第一个完全基于客观公开数据的智库评价项目，项目目标旨在构建公开透明的评价指标体系，增强评估结果的客观性、科学性、咨询性；通过对全球智库的评议（排名）分析，比较不同智库的优势及劣势，为我国智库建设和更好发挥智库作用提供建议。最终构建基于调研分析、基础数据、评价研究，涵盖“评价指标体系、评价与咨询报告、数据库、数据管理与发布平台”等在内的智库评价网络系统。</p>
        <h3>1 评价流程</h3>
        <p
          class="text"
        >在智库排行研究中，项目组按照“工程科技思想库的基本特点→工程科技思想库评估指标→共性指标抽取→个性指标选取→工程科技思想库评价体系”这条技术路线进行研究,技术路线详见图1，在调研国内外智库排行的研究与发展现状的基础上，对指标体系和影响力构成进行比较研究，构建RIPO指标体系框架，从智库资源（R，Resource indicators）、智库产出（O，Output indicators）、智库知名度（P，Popularity indicators）、智库影响力（I，Impact indicators）四个维度对全球智库进行综合评价，并通过公开途径，获取用于计算榜单排名的大量客观事实数据。同时，根据数据的特点，确定适用的建模方法及权重，继而得到最终的排行榜数据。</p>
        <img src="static/img/blog/bg-2.png" class="tankImg" />
        <p class="tz">图1 全球智库影响力评价项目流程图</p>
        <h3>2 项目数据集</h3>
        <h3 style="font-weight: 500;;margin-top:10px" class="text">1) 智库遴选池数据集</h3>
        <p
          class="text"
        >作为智库评价的客体，来源智库的选择是保证智库研究可靠性的重要方面。为保证智库研究数据的真实、权威、可信，减少用户识别数据的成本，在对全球各智库评价项目进行充分调研分析基础之上，项目组提出了智库遴选的五大原则：</p>
        <p style="text-indent: 4em;">一是智库需要享有一定国际或国内知名度；</p>
        <p style="text-indent: 4em;">二是智库具有比较完善的组织架构与运行机制；</p>
        <p style="text-indent: 4em;">三是智库有较强的资金和人才吸引能力；</p>
        <p style="text-indent: 4em;">四是智库有较强的政策和学术影响力；</p>
        <p style="text-indent: 4em;">五是智库需有较高社会评价。</p>
        <p
          class="text"
        >根据此原则，从调研所及的1200多家智库机构中筛选了400家左右智库样本作为评价研究的对象。同时，以发展的眼光，与历年智库评价对比，总结了智库样本微调名录。</p>
        <h3 style="font-weight: 500;;;margin-top:10px" class="text">2) 智库指标数据集</h3>

        <p
          class="text"
        >从理论层面到实践层面，课题组一方面参考借鉴了国内外主要评估系统的经验，另一方面结合本课题研究目标的独特性，同时根据数据获取情况以及模型试算的反馈进行不断地调整，对指标体系进行了多轮比较筛选和修正，摒弃了所有主观指标，经过多轮修正，全部采用客观指标，课题组基本确立了可行的评价指标体系。</p>
        <p
          class="text"
        >指标数据完全基于公开数据进行定量评价，本智库项目组通过遍历、检索智库机构的主页、数据库等公开途径，获得了用于计算榜单排名的大量客观事实数据。主要数据来源包括：官方网站，论文数据库（WOS，CNKI，中华数字书苑，ProQuest平台外文报刊库，Alexa网站数据统计等）。由人工进行识别判定大量的事实型数据如智库领导人旋转门、机构收入、研究项目等，基于此进行数据挖掘和情报分析。</p>
        <h3>3 项目的相关成果</h3>
        <h3 style="font-weight: 500;;margin-top:10px" class="text">1) 评价项目数据管理与发布平台</h3>
        <p
          class="text"
        >为了更好的管理智库数据，智库项目组建立了评价项目数据管理与发布平台，该平台包含工作平台和发布网站。工作平台仅供项目内部使用，主要功能是对本项目实施过程中的工作流程分派、数据采集与治理、数据变更、数据交换、数据试算、榜单预发布与正式发布进行管理（图2）。发布网站（图3）面对公众用户，实现榜单发布、全球智库导航、可视化比较与分析功能。</p>
        <img src="static/img/blog/bg-3.png" class="tankImg" />
        <p class="tz">图2 智库工作平台</p>
        <img src="static/img/blog/bg-4.png" class="tankImg" />
        <p class="tz">图3 智库发布平台</p>
        <h3 style="font-weight: 500;;margin-top:10px" class="text">2) 全球智库排行评价年度报告</h3>
        <p
          class="text"
        >最终以事实数据为基础，调节各项评价指标权重，确定标准化模型。目前，项目组已经建设完成全球智库索引数据库、全球智库评价数据库，建立了智库量化评价标准和评价指标体系，自2017年起，连续三年发布《全球智库影响力评价报告》，为建设国家高端智库提供可行性建议，在业界广获好评。</p>
        <img src="static/img/blog/bg-5.jpg" class="tankImg" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'think',
  data () {
    return {
      msg: ''
    }
  },
  methods: {
    go () {
      window.open('https://ciraa.zju.edu.cn/report/report08.pdf', '_blank')
    }
  }
}
</script>

<style lang="scss">
.blog-view {
  margin-top: 5vh;
  width: 50vw;
  .tankImg {
    width: 50vw;
    margin: 20px 0;
  }
  .blog-content {
    font-size: 16px;
    line-height: 28px;
    color: #222;
    word-wrap: break-word;
    p {
      margin-top: 16px;
      margin-bottom: 16px;
    }
    h3 {
      font-weight: 600;
    }
    .tz {
      font-weight: 600;
      text-align: center;
    }
    .text {
      text-indent: 2em;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/blog/thinkTank.vue